import { GET } from './Httpr.js';



export async function getContnetsLectureId(request){
    let url = "content/byActivity";
    let requestData = {
        id_activity: request
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getActivityContent(id){
    let url = "content/byId";
    let requestData = {
        id: id
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getVideoActivityById(id){
    let url = "content/getVideo";
    let requestData = {
        id: id
    }

    let rsp = await GET(url, requestData);

    return rsp;
}


export async function getDownloadActivityById(id){
    let url = "content/getDownload";
    let requestData = {
        id: id
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getQuestionActivityById(id){
    let url = "content/getQuestion";
    let requestData = {
        id: id
    }

    let rsp = await GET(url, requestData);

    return rsp;
}